<template>
  <section class="search-suggestions">
    <h4 class="title">Sugestões</h4>
    <campaign-list
      search
      class="suggestions"
      :has-favorite="false"
      :campaigns="suggestions"
      :hide-cashback="hideCashback"
      @click-campaign="$listeners['click-suggestion']"
    />
  </section>
</template>

<script>
import CampaignList from '@components/Campaign/CampaignList'

export default {
  components: { CampaignList },
  props: {
    results: {
      type: Array,
      required: true
    },
    hideCashback: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    suggestions () {
      return (
        this.results.length <= 3
          ? this.results
          : this.results.slice(0, 3)
      )
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.search-suggestions {
  box-shadow: 1px 1px 4px 0 $shadow-color;

  & > .title {
    padding: 20px 15px 0;
    margin: 0 0 5px;
    color: $text-color;
    font-size: 14px;
    font-family: $title-font-family;
    line-height: 16px;
    font-weight: 400;
  }

  & > .suggestions {
    overflow: auto;
    display: block;
    max-height: calc(100vh - 110px);
    padding: 0 15px 60px;
    & > .item.campaign-card {
      margin: 0;

      & > .card {
        margin-top: 10px;
      }
    }

    @include desktop {
      padding-bottom: 20px;
      & > .item.campaign-card { background-color: $background-color; }
    }
  }

  @include desktop { position: absolute; }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/SearchSuggestions.vue